import GjwDialog from './src/GjwDialog.vue'

GjwDialog.install = function(Vue) {
  Vue.component(GjwDialog.name, GjwDialog)
}

export default GjwDialog
